// Opens the harmonised EU notice on the legal guarantee (snippets/gewaehrleistung-hinweis.liquid).
//
// Event delegation on document instead of per-button listeners: the cart drawer and the
// cart footer are re-rendered through the Section Rendering API on every cart change, and
// buttons bound directly would lose their listener after the first update.
(function () {
  var dialog = null;
  var schliessZeit = 0;

  function holeDialog() {
    if (!dialog) dialog = document.getElementById('GewaehrleistungDialog');
    return dialog;
  }

  function oeffnen() {
    var d = holeDialog();
    if (!d || d.open) return;
    // The notice is loaded on first open only.
    var img = d.querySelector('img[data-src]');
    if (img && !img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
    if (typeof d.showModal === 'function') {
      d.showModal();
    } else {
      d.setAttribute('open', '');
    }
  }

  // Narrow screens only (the hint is hidden by CSS on wide ones, where the sheet already
  // fits legibly): toggle between "complete at screen width" and "legible, scrollable".
  // The tapped spot is kept under the finger, otherwise the enlarged sheet would open at
  // its top-left corner and the reader would have to look for the passage again.
  function setzeZoom(d, gross, event) {
    var blatt = d.querySelector('[data-gewaehrleistung-zoom]');
    var rumpf = d.querySelector('.gewaehrleistung-dialog__rumpf');
    var hinweis = d.querySelector('.gewaehrleistung-dialog__zoomhinweis');
    if (!blatt || !rumpf) return;

    var fx = 0.5;
    var fy = 0;
    if (event && gross) {
      var r = blatt.getBoundingClientRect();
      if (r.width > 0 && r.height > 0) {
        fx = (event.clientX - r.left) / r.width;
        fy = (event.clientY - r.top) / r.height;
      }
    }

    d.classList.toggle('gewaehrleistung-dialog--gross', gross);
    var text = blatt.getAttribute(gross ? 'data-text-gross' : 'data-text-klein');
    blatt.setAttribute('aria-pressed', gross ? 'true' : 'false');
    blatt.setAttribute('aria-label', text);
    if (hinweis) hinweis.textContent = hinweis.getAttribute(gross ? 'data-text-gross' : 'data-text-klein');

    if (gross) {
      var b = blatt.getBoundingClientRect();
      var ru = rumpf.getBoundingClientRect();
      rumpf.scrollLeft = Math.max(0, fx * b.width - ru.width / 2);
      rumpf.scrollTop = Math.max(0, fy * b.height - ru.height / 2);
    } else {
      rumpf.scrollLeft = 0;
    }
  }

  function schliessen() {
    var d = holeDialog();
    if (!d) return;
    if (typeof d.close === 'function') {
      d.close();
    } else {
      d.removeAttribute('open');
    }
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-gewaehrleistung-oeffnen]')) {
      event.preventDefault();
      oeffnen();
      return;
    }
    if (event.target.closest('[data-gewaehrleistung-schliessen]')) {
      schliessen();
      return;
    }
    var zoom = event.target.closest('[data-gewaehrleistung-zoom]');
    if (zoom) {
      var zd = holeDialog();
      var zh = zd && zd.querySelector('.gewaehrleistung-dialog__zoomhinweis');
      // Wide screens: the hint is hidden and the sheet already legible — nothing to toggle.
      if (!zh || getComputedStyle(zh).display === 'none') return;
      setzeZoom(zd, !zd.classList.contains('gewaehrleistung-dialog--gross'), event);
      return;
    }
    // Click on the backdrop: the event target is the dialog element itself.
    var d = holeDialog();
    if (d && event.target === d) schliessen();
  });

  document.addEventListener(
    'close',
    function (event) {
      var d = holeDialog();
      if (event.target !== d) return;
      schliessZeit = Date.now();
      // Every opening starts with the complete sheet again.
      setzeZoom(d, false);
    },
    true
  );

  // Escape closes the dialog on keydown; the matching keyup then reaches the cart drawer,
  // which closes itself on keyup Escape. Swallow that one keyup so only the dialog closes.
  window.addEventListener(
    'keyup',
    function (event) {
      if (event.key === 'Escape' && Date.now() - schliessZeit < 500) {
        event.stopPropagation();
        schliessZeit = 0;
      }
    },
    true
  );
})();
